import { render, staticRenderFns } from "./CheckboxIndigo.vue?vue&type=template&id=7566d247&"
import script from "./CheckboxIndigo.vue?vue&type=script&lang=js&"
export * from "./CheckboxIndigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports